import React, { useRef } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const TextEditor = ({
  value,
  onChange,
  placeholder = "Start typing here...",
  className = "",
}) => {
  // Toolbar options for customization
  const toolbarOptions = [
    [{ header: [1, 2, 3, false] }], // Headers
    ["bold", "italic", "underline", "strike"], // Formatting buttons
    [{ list: "ordered" }, { list: "bullet" }], // Lists
    ["blockquote", "code-block"], // Block quotes/code
    ["link", "image", "video"], // Links, images and videos
    [{ align: [] }], // Text alignment
    [{ color: [] }, { background: [] }], // Text color and background color
    ["clean"], // Remove formatting
  ];

  const modules = {
    toolbar: toolbarOptions,
  };

  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "list",
    "bullet",
    "blockquote",
    "code-block",
    "link",
    "image",
    "video",
    "color",
    "background",
    "align",
  ];

  const quillRef = useRef(null);
  return (
    <div className="flex flex-col gap-2">
      <ReactQuill
        value={value}
        onChange={onChange}
        modules={modules}
        formats={formats}
        placeholder={placeholder}
        ref={quillRef}
        theme="snow"
        className={`rounded-md ${className}`}
        style={{ height: "15rem", borderRadius: "6px", background: "white" }}
      />
    </div>
  );
};

export default TextEditor;
